<template>
  <div>
    <!-- <el-scrollbar wrapClass="scrollbar-wrapper"> -->
    <el-menu :default-active="activeNav"
             class="el-menu-vertical-demo"
             router
             unique-opened
             :collapse="isCollapse"
             @open="handleOpen"
             @close="handleClose">
      <label v-for="(info, key) in routes"
             :key="key">
        <!-- 只有一级路由 -->
        <template v-if="!info.hidden && !info.haveChild">
          <el-menu-item class="three-menu" :index="info.path + '/' + info.children[0].path"
                        :key="key+1"
                        v-if="!info.children[0].hidden">
            <i class="my-menu-icon-2"
              :class="info.meta.icon"></i>
            <span slot="title">{{ info.meta.title }}</span>
            <!-- <i class="menu-icon-right el-icon-arrow-right"></i> -->
          </el-menu-item>
        </template>
        <!-- 含二级路由 -->
        <template v-else-if="!info.hidden && info.haveChild">
          <!-- 一级 -->
          <el-submenu :index="key+''"
                      v-if="info.children">
            <template slot="title">
              <i class="my-menu-icon"
                 :class="info.meta.icon"></i>
              <span>{{ info.meta.title }}</span>
            </template>
            <label v-for="(item, index) in info.children" :key="index">
                <template >
                  <!-- 二级 -->
                  <el-menu-item class="three-menu" :index="info.path +'/'+item.path"
                                :key="item.path"
                                v-if="!item.hidden">
                    <!-- <i class="my-menu-icon-2" :class="item.meta.icon"></i> -->
                    <i class="my-menu-icon-3" :class="item.meta.icon"></i>
                    <span slot="title">{{ item.meta.title }}</span>
                  </el-menu-item>
                </template>
            </label>
          </el-submenu>
        </template>
      </label>
    </el-menu>
    <div class="bar-menu-right"
         :class="{'hide-bar': isCollapse}" v-if="false">
      <div v-show="!isCollapse"
           @click="toggleSideBar"
           class="show-true">
        <i class="el-icon-d-arrow-left"></i>
      </div>
      <!-- 收起 -->
      <div v-show="isCollapse"
           @click="toggleSideBar"
           class="show-true">
        <i class="el-icon-d-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      id: this.$route.params.id,
      activeNav: '/userList'
      // routes: []
    }
  },
  computed: {
    routes () {
      return this.$store.getters.routers
    },
    isCollapse () {
      return this.$store.getters.isCollapse
    }
  },
  watch: {
    $route: {
      handler (n, o) {
        this.routeHidden(this.routes)
        // if (n.name === 'monitor') {
        //   this.activeNav = '/data/realTime'
        // } else {
        //   this.activeNav = n.path
        // }

        // console.log(this.$route)
        // 一级导航页选中设置
        // this.routeHidden(this.routes)
        // console.log(this.activeNav)
      },
      deep: true
    }
  },
  created () {
    // this.routes = this.$router.options.routes
    // console.log(this.routes)

    // let rr = []
    // this.routes.forEach(item => {
    //   let oneInfo = []
    //   if (item.children) {
    //     item.children.forEach(val => {
    //       if (!val.hidden) {
    //         oneInfo.push({
    //           id: val.meta.roles[0],
    //           type: 2,
    //           name: val.meta.title,
    //           parentId: item.meta.roles[0]

    //         })
    //       }
    //     })
    //   }
    //   if (!item.hidden) {
    //     rr.push({
    //       id: item.meta.roles[0],
    //       type: 1,
    //       name: item.meta.title,
    //       children: oneInfo

    //     })
    //   }
    // })
    // console.log('routes', JSON.stringify(rr))

    this.routeHidden(this.routes)
    // console.log('menuttt', this.activeNav, this.$route.path, this.activeNav === this.$route.path)
  },
  components: {},
  methods: {
    routeHidden (arr) {
      arr.forEach(ele => {
        if (!ele.children) {
          // 非导航页
          if (this.$route.name === ele.name && ele.hidden) {
            // navName 设置导航选中项
            if (ele.navName) {
              // if 判断适用于同一页面从不同页面跳转而来
              if (ele.name === '123') { // 组态
                let pageType = this.$route.query.type
                console.log('pageType', pageType)

                if (pageType === '1') {
                  ele.meta.title = '一次图'
                  this.activeNav = ele.navName
                } else {
                  ele.meta.title = '平面图'
                  this.activeNav = ele.navName2
                }
              } else if (ele.name === 'monitorDetail') {
                // formType 4 工艺监测管理 5 气体监测管理 共用详情页面
                let fromType = parseInt(this.$route.params.formType) // 1: 巡检详情 2:巡检任务管理
                let arr = ele.navName.split('/')
                this.activeNav = '/' + arr[1] + '/' + arr[2] + '/' + ele.meta['parentName' + fromType]
              } else {
                this.activeNav = ele.navName
              }
            }
          } else if (this.$route.name === ele.name && !ele.hidden) {
            // 一级导航页
            this.activeNav = this.$route.path
            // console.log(this.activeNav)
          }
          // console.log(this.$route)
        } else {
          this.routeHidden(ele.children)
        }
      })
    },
    handleOpen () { },
    handleClose () { },
    toggleSideBar () {
      this.$store.dispatch('setIsCollapse', !this.isCollapse)
      console.log(this.$store.getters.isCollapse)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-side-bar {
  position: absolute;
  right: -14px;
  z-index: 9999999999;
}
.bar-menu-right {
  position: fixed;
  top: calc(50% - 100px);
  left: 210px;
  transition: all 0.28s;
  font-size: 14px;
  // transition: all 0.01s;
}
.hide-bar {
  left: 0px;
  transition: all 0.01s;
}
</style>
